import { Button } from "@msuite/ui/button";
import { useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { type CellContext, RowActionsWrapper, useDataTableContext } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { ProjectMeasurement } from "@msuite/utils/types";
import { client } from "@/hono";

export function RowActions({ cell }: CellContext<ProjectMeasurement, "actions">) {
	/** Context */
	const context = useDataTableContext();
	const closeLoader = useLoading();
	const openLoader = useLoading();

	const loaders = {
		close: closeLoader,
		open: openLoader,
	};

	/** Functions */
	async function handleOnMarkStatement(type: "open" | "close") {
		try {
			loaders[type].start();
			const batchIds = context.getSelectedRowIds();
			const response = await client.measurements[":projectId"].measurements[":ticketAssignmentId"][
				type
			].$post({
				param: {
					projectId: cell.row.original.projectId,
					ticketAssignmentId: cell.row.original.id,
				},
				json: {
					batchIds,
				},
			});
			await responseHandler(response);
			await context.refetch?.();
			context.table.resetRowSelection();
		} catch (error) {
			console.error(error);
		} finally {
			loaders[type].stop();
		}
	}

	/** Render */
	return (
		<RowActionsWrapper to={null}>
			{cell.row.original.isClosed && (
				<Button
					size="xxs"
					icon={<Icon name="RefreshCcw" />}
					onClick={() => handleOnMarkStatement("open")}
					isLoading={loaders.open.isLoading}
					isDisabled={!cell.row.original.isClosed}
					variant="danger-ghost"
				/>
			)}
			<Button
				size="xxs"
				icon={<Icon name="Check" />}
				onClick={() => handleOnMarkStatement("close")}
				isLoading={loaders.close.isLoading}
				isDisabled={!cell.row.original.statement || cell.row.original.isClosed}
			/>
		</RowActionsWrapper>
	);
}
